import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="kickoff-outcomes-toggle"
export default class extends Controller {
  static targets = ["emptyState", "generateForm"]

  showForm() {
    this.emptyStateTarget.classList.add("hidden")
    this.generateFormTarget.classList.remove("hidden")
  }

  cancelGenerate() {
    this.generateFormTarget.classList.add("hidden")
    this.emptyStateTarget.classList.remove("hidden")
  }
}
